export const LOYALTY_CLAIM_GO_BUTTON_ACTION = "LOYALTY_CLAIM_GO_BUTTON_ACTION";
export const LOYALTY_CLAIM_GO_BUTTON_SUCCESS = "LOYALTY_CLAIM_GO_BUTTON_SUCCESS";
export const LOYALTY_CLAIM_API_ERROR_ACTION = "LOYALTY_CLAIM_API_ERROR_ACTION";
